/* eslint-disable react-refresh/only-export-components */
import { ReactNode, createContext, useContext } from "react";
import type { PersonFormDefaults } from "@/components/people/PersonFormDialog";

export interface QuickAddRequestDefaults {
  title?: string;
  type?: "care" | "facility" | "admin" | "other" | "reimbursement";
  personId?: string;
  personName?: string;
}

export interface QuickAddContextValue {
  openPersonDialog: (defaults?: PersonFormDefaults) => void;
  openContributionDialog: () => void;
  openRequestDialog: (defaults?: QuickAddRequestDefaults) => void;
  openEventDialog: () => void;
  openServiceDialog: () => void;
  openProjectDialog: () => void;
  openMessageDialog: () => void;
  /** Capture the Quick Add button position for genie animation. */
  captureGenieOrigin: () => void;
}

const QuickAddContext = createContext<QuickAddContextValue | null>(null);

export function useQuickAdd() {
  const context = useContext(QuickAddContext);
  if (!context) {
    throw new Error("useQuickAdd must be used within QuickAddProvider.");
  }
  return context;
}

/** Optional access for reusable dialogs that can also render in isolated tests/stories. */
export function useOptionalQuickAdd() {
  return useContext(QuickAddContext);
}

interface QuickAddProviderProps {
  children: ReactNode;
  value: QuickAddContextValue;
}

export function QuickAddProvider({ children, value }: QuickAddProviderProps) {
  return <QuickAddContext.Provider value={value}>{children}</QuickAddContext.Provider>;
}
